import React, { useEffect, useState, useRef, useCallback } from "react";
import Card from "./Card";
import "../../styles/CaseStatusCard.css";

const ArrowIcon = ({ width = 15, height = 15 }) => (
  <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.98096 9.95215L7.96169 5.97142L3.98096 1.99069" stroke="#B4BAC2" strokeWidth="1.12" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const getStatusClass = (status = "") => {
  switch (status.trim()) {
    case "Damage Assessment":
      return "status-inactive";
    case "Pre-Construction":
      return "status-active";
    case "Environmental Review":
      return "status-update";
    case "Award":
      return "status-purple"
    case "Team Lead Review":
      return "status-danger";
    case "Construction":
      return "status-one";
    case "Eligibility Determination Review":
      return "status-two";
    case "DOB Reivew":
      return "status-three"
    case "Communication":
      return "status-danger"
    default:
      return "status-other";
  }
};

// Pre-Construction status
//  Damage Assessment status
//  Environmental Review status
//  Award status
//  Team Lead Review status
//  Construction status
//  Eligibility Determination Review status
//  Damage Assessment status
//  Intake status
//  DOB Review status
//  Communication status
//  Pre-Construction status
//  Damage Assessment status
//  Environmental Review status
//  Award status
//  Team Lead Review status
//  Construction status
//  Eligibility Determination Review status
//  Damage Assessment status
//  Intake status
//  DOB Review status
//  Communication status

const CaseStatusCard = ({
  count = 0, items = [], small = false, subText, handleSelection
}) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const previousItemsRef = useRef(items);  // To store the previous items list

  const handleItemClick = useCallback((index, itemText) => {
    setSelectedIndex(index); // Update the selected index
    handleSelection(itemText); // Pass the item text to parent
  }, [handleSelection]);

  useEffect(() => {
    // Only trigger this effect when items have changed
    if (JSON.stringify(items) !== JSON.stringify(previousItemsRef.current)) {
      if (items.length > 0) {
        setSelectedIndex(0); // Set the first item as selected
        handleSelection(items[0].text); // Notify the parent with the first item
      }
      previousItemsRef.current = items; // Update the previous items reference
    }
  }, [items, handleSelection]);

  return (
    <Card className={`action-card ${small ? "small" : ""}`}>
      <div className="action-count">
        {count}
        {/* <ArrowIcon width={24} height={24} /> */}
      </div>
      <span className="item-subText">{subText}</span>
      <ul className="action-list">
        {items.map((it, idx) => (
          <li
            key={idx}
            className={`action-item ${it.type || ""} ${selectedIndex === idx ? "active" : ""}`}
            onClick={() => handleItemClick(idx, it.text)} // Pass the index along with item text
          >
            <div className="wrap-before">
              <span className="item-text">{it.text}</span>
              <span className="item-text muted">{it.duration}</span>
              <div className="status-wrap">
                <span className={`item-bullet ${getStatusClass(it.status)}`}>
                  {it.status}
                </span>
              </div>
            </div>
            <div className="item-arrow">
              <ArrowIcon width={15} height={15} />
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
};

export default CaseStatusCard;